import { render, staticRenderFns } from "./CookingView.vue?vue&type=template&id=5fa1304d&scoped=true"
import script from "./CookingView.vue?vue&type=script&lang=js"
export * from "./CookingView.vue?vue&type=script&lang=js"
import style0 from "./CookingView.vue?vue&type=style&index=0&id=5fa1304d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa1304d",
  null
  
)

export default component.exports